import React  from 'react';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import MediaInfoComponent from '../../../../common/components/common/media-info.component';
import { useAppSelector } from '../../../../hooks/hooks';
import { selectListItems } from '../../../../redux/library/selector';
import GlobalDbnRoutingModelsBasicInfoComponent from './global-dbn-routing-models-basic-details';

export const GlobalDbnRoutingModelsComponent = ({PlanType,handleInnerChange,subselectedCategory,FulfillmentExtent,LifeCycleStatus,handleInnerFormChange,selectedCategory, 
 back,handleFormSubmit}: any) => {
    const libraryData = useAppSelector(selectListItems)

  const tabItems=[
    {
        id:1,
        title:'New Service Category Group',
        component:<GlobalDbnRoutingModelsBasicInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        handleInnerChange={handleInnerChange}
        subselectedCategor={subselectedCategory}
        selectedCategory={selectedCategory}
        LifeCycleStatus={LifeCycleStatus}
        FulfillmentExtent={FulfillmentExtent}
        PlanType={PlanType}
        />,
    isVisible:true,
    }
    
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       </div>
  )
}
export default GlobalDbnRoutingModelsComponent;
